// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@werner/XDL/Utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);

    const parsedQuery = parseQueryString<{ reset?: string }>(location.search);

    return {
        isResettingPassword: parsedQuery.reset?.toLowerCase() === "true",
    };
};

export interface PageTitleStyles {
    wrapper?: InjectableCss;
    title?: InjectableCss;
}

export const pageTitleStyles: PageTitleStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin: 0 0 75px;
            ${xScreen("lte", "md")} {
                margin: 0 0 35px;
            }
        `,
    },
    title: {
        css: css`
            &.title-only {
                margin: 0 0 75px;
                ${xScreen("lte", "md")} {
                    margin: 0 0 35px;
                }
            }
        `,
    },
};
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const ResetPasswordPageTitle: React.FC<Props> = ({ isResettingPassword }) => {
    return (
        <Typography
            className="title-only"
            {...pageTitleStyles.title}
            variant="h2"
            as="h1"
            data-test-selector="PageTitle"
        >
            {isResettingPassword ? translate("Reset Password") : siteMessage("AccountActivation_CreatePassword")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ResetPasswordPageTitle),

    definition: {
        displayName: "Page Title",
        group: "Reset Password",
        allowedContexts: ["ResetPasswordPage"],
    },
};

export default widgetModule;
